import { render } from "./IconEmail.vue?vue&type=template&id=499811cc"
import script from "./IconEmail.vue?vue&type=script&lang=js"
export * from "./IconEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__